/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-north-1",
    "aws_appsync_graphqlEndpoint": "https://b3flr5m7mzde7ib4qet5ecb2ei.appsync-api.eu-north-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-north-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-lgsnmcklwzeynbzqklhlkasof4",
    "aws_cloud_logic_custom": [
        {
            "name": "klarna",
            "endpoint": "https://8j699mn3vf.execute-api.eu-north-1.amazonaws.com/production",
            "region": "eu-north-1"
        },
        {
            "name": "payson",
            "endpoint": "https://uvqmho3z1l.execute-api.eu-north-1.amazonaws.com/production",
            "region": "eu-north-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-north-1:38bf78c5-0b97-4139-a82a-390c8dd8785d",
    "aws_cognito_region": "eu-north-1",
    "aws_user_pools_id": "eu-north-1_9tgbsHQTR",
    "aws_user_pools_web_client_id": "1pmf4kqboob929pebib0s65kib",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "submissions193653-production",
    "aws_user_files_s3_bucket_region": "eu-north-1"
};


export default awsmobile;
